<template>
  <path
      :fill="color"
      d="M10.8838 10L16.25 4.63381L15.3662 3.75L10 9.11619L4.63394 3.75L3.75 4.63381L9.11619 10L3.75 15.3662L4.63394 16.25L10 10.8838L15.3662 16.25L16.25 15.3662L10.8838 10Z"/>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3498db",
    }
  }
}
</script>
